module.exports = {
    theme: {
        extend: {
            colors: {
                palette: {
                    'primary': '#112843',
                    'primary-enhanced': '#193D61',
                    'secondary-400': '#FFBF4A',
                    'secondary-500': '#FFA41D',
                    'secondary-600': '#F98107',
                    'accent-500': '#3EA6F3',
                    'accent-600': '#2989E7',
                    'accent-700': '#2175D9',
                    'gray-400': '#9CA3AF',
                    'slate': '#F1F5F9',
                    'slate-200': '#E2E8F0',
                    'slate-dark': '#475569',
                    'slate-darker': '#334155',
                }
            },
        },
        fontFamily: {
            roboto: ['Roboto', 'sans-serif'],
        },
    },

    plugins: [
        require('@tailwindcss/aspect-ratio'),
        require('@tailwindcss/typography'),
        require('@tailwindcss/forms'),
        require('tailwind-scrollbar'),
    ],

    content: [
        __dirname + '/galaxy/modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/app/Modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/resources/**/*.{vue,js,scss,php}',
        __dirname + '/config/**/*.{vue,js,scss,php}',
    ],
};
